import { defineStore } from 'pinia'

import { getPublicSettings } from '@/api/settings'
import { setGlobalCurrency } from '@/utils/formatters'

const toBool = (v) => v === true || v === 1 || v === '1' || v === 'true'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    currency: 'NGN',
    hotelName: '',
    phone: '',
    email: '',
    address: '',
    vatEnabled: false,
    vatPercentage: 0,
    paystackEnabled: true,
    bankTransferEnabled: false,
    bankName: '',
    bankAccountName: '',
    bankAccountNumber: '',
    bankInstructions: '',
    social: {
      facebook: '',
      instagram: '',
      twitter: '',
      linkedin: '',
      youtube: '',
      tiktok: '',
      whatsapp: ''
    },
    loaded: false
  }),

  actions: {
    apply(data) {
      if (data.currency) this.currency = data.currency
      this.hotelName = data.hotel_name || this.hotelName
      this.phone = data.phone || this.phone
      this.email = data.email || this.email
      this.address = data.address || this.address
      if ('vat_enabled' in data) this.vatEnabled = toBool(data.vat_enabled)
      if ('vat_percentage' in data) this.vatPercentage = Number(data.vat_percentage) || 0
      if ('paystack_enabled' in data) this.paystackEnabled = toBool(data.paystack_enabled)
      if ('bank_transfer_enabled' in data)
        this.bankTransferEnabled = toBool(data.bank_transfer_enabled)
      this.bankName = data.bank_name ?? this.bankName
      this.bankAccountName = data.bank_account_name ?? this.bankAccountName
      this.bankAccountNumber = data.bank_account_number ?? this.bankAccountNumber
      this.bankInstructions = data.bank_instructions ?? this.bankInstructions
      this.social = {
        facebook: data.facebook_url || '',
        instagram: data.instagram_url || '',
        twitter: data.twitter_url || '',
        linkedin: data.linkedin_url || '',
        youtube: data.youtube_url || '',
        tiktok: data.tiktok_url || '',
        whatsapp: data.whatsapp_number || ''
      }
      setGlobalCurrency(this.currency)
    },

    async load() {
      try {
        const res = await getPublicSettings()
        this.apply(res.data.data || res.data || {})
      } catch (e) {
        // Keep defaults if settings can't be reached.
      } finally {
        this.loaded = true
      }
    }
  }
})
